var React = require('react');

module.exports = React.createClass({
  render: function() {
    var baseProps = {
      'width': '11px',
'height': '17px',
'viewBox': '0 0 11 17',
'version': '1.1',
'xmlns': 'http://www.w3.org/2000/svg',
'xmlnsXlink': 'http://www.w3.org/1999/xlink',
      className: 'svg-icon',
      dangerouslySetInnerHTML: {
        __html: " <!-- Generator: Sketch 45.2 (43514) - http://www.bohemiancoding.com/sketch --> <title>phone</title> <desc>Created with Sketch.</desc> <defs></defs> <g id=\"SUPER-ADMIN\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"> <g id=\"A-5.5-Candidate-Report-after-filter\" transform=\"translate(-192.000000, -646.000000)\" fill-rule=\"nonzero\" fill=\"#9E9E9E\"> <g id=\"Group-8\" transform=\"translate(188.000000, 573.000000)\"> <g id=\"phone\" transform=\"translate(4.000000, 73.000000)\"> <path d=\"M0,0 L0,15.2864957 C0,16.2219978 0.762998257,16.9849952 1.69849952,16.9849952 L8.49249761,16.9849952 C9.42799972,16.9849952 10.1909971,16.2219978 10.1909971,15.2864957 L10.1909971,3.39699904 C10.1909971,2.46149778 9.42799972,1.69849952 8.49249761,1.69849952 L1.69849952,1.69849952 L1.69849952,0 L0,0 Z M2.1231244,3.39699904 L8.06787273,3.39699904 C8.32331092,3.39699904 8.49249761,3.56618573 8.49249761,3.82162392 L8.49249761,8.06787273 C8.49249761,8.32331092 8.32331092,8.49249761 8.06787273,8.49249761 L2.1231244,8.49249761 C1.86768621,8.49249761 1.69849952,8.32331092 1.69849952,8.06787273 L1.69849952,3.82162392 C1.69849952,3.56618573 1.86768621,3.39699904 2.1231244,3.39699904 Z\" id=\"Shape\"></path> </g> </g> </g> </g> ",
      }
    };
    var props = Object.assign({}, baseProps, this.props);
    return React.createElement('svg', props);
  },
});



// WEBPACK FOOTER //
// ./node_modules/dk-ui-lib/assets/phone.svg